export default __webpack_public_path__ + "static/media/SpelevatorPart_3.256.9aa026bb.png";